import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import AnnouncementPopup from "src/components/reusable/AnnouncementPopup";
import { getUserAnnouncements } from "src/services/NotificationAnnouncementsAPIs";

const AnnouncementPopupWrapper: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [announcement, setAnnouncement] = useState<any>(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const list = await getUserAnnouncements();
        const firstAnnouncement = list?.[0];

        if (firstAnnouncement) {
          setAnnouncement(firstAnnouncement);
          setShowPopup(true);
        }
      } catch (err) {
        console.error("Failed to fetch announcements:", err);
      }
    };

    fetch();
  }, []);

  if (!showPopup || !announcement) {return null;}

  const handleAction = () => {
    const url = announcement?.url;
    if (url) {
      window.open(url, "_blank");
    }
    setShowPopup(false);
  };

  // Rendered as a sibling of <Sidebar> in the app shell's flex row, so it
  // must never be a normal layout participant — a plain in-flow render here
  // stretches to fill the row's height (flex default `align-items: stretch`)
  // and, under RTL's native row reversal, that empty box lands at the
  // newly-exposed far edge instead of quietly overlaying the page. A portal
  // takes it out of that flex flow entirely, regardless of language/direction.
  return createPortal(
    <AnnouncementPopup
      title={announcement?.title ?? "No Title"}
      content={announcement?.content ?? "No content available."}
      logo={ "/images/DpLogo.png"}
      icon={announcement?.icon ?? "/Icons/Group 13.svg"}
      buttonText={announcement?.url ? "Check it out" : "OK"}
      onClose={() => setShowPopup(false)}
      onButtonClick={handleAction}
    />,
    document.body
  );
};

export default AnnouncementPopupWrapper;
